export default __webpack_public_path__ + "static/media/freewheel.125f4245.png";